// (function () {
//     'use strict';
//
//     angular
//         .module('estadisticas')
//         .service('InformeActionsService', InformeActionsService);

    InformeActionsService.$inject = ['dialogService', '$q', '$http', '$log', 'DialogsService'];
    export default function InformeActionsService(dialogService, $q, $http, $log, DialogsService) {

        var TAG = 'InformeActionsService: ';

        var DIALOG_INFORME_EDIT_TEMPLATE = require('./add/dialog-informes-add.html');
        var DIALOG_INFORME_EDIT_ID = 'dialog-informes-add';
        var DIALOG_INFORME_COMPARTIR_TEMPLATE = require('./compartir/dialog-informes-compartir.html');
        var DIALOG_INFORME_COMPARTIR_ID = 'dialog-informes-compartir';
        var DIALOG_ADD_A_INFORME_TEMPLATE = require('./add-a-informe/dialog-informes-add-a-informe.html');
        var DIALOG_ADD_A_INFORME_ID = 'dialog-informes-add-a-informe';

        return {
            anyadirInforme: function () {
                var options = {title: 'Añadir informe'}; //TODO: Cambiar
                var datos = {};
                var opcionesExtra = {deshabilitarBotones: true};

                return dialogService.open(DIALOG_INFORME_EDIT_ID, DIALOG_INFORME_EDIT_TEMPLATE, datos, options, opcionesExtra);
            },
            editarInforme: function (informeId) {
                var options = {title: 'Editar informe'}; //TODO: Cambiar
                var datos = {informeId: informeId};
                var opcionesExtra = {deshabilitarBotones: true};

                return dialogService.open(DIALOG_INFORME_EDIT_ID, DIALOG_INFORME_EDIT_TEMPLATE, datos, options, opcionesExtra);
            },
            compartirInforme: function (informeId) {
                var options = {title: 'Compatir informe'}; //TODO: Cambiar
                var datos = {informeId: informeId};
                var opcionesExtra = {deshabilitarBotones: true};

                return dialogService.open(DIALOG_INFORME_COMPARTIR_ID, DIALOG_INFORME_COMPARTIR_TEMPLATE, datos, options, opcionesExtra);
            },
            anyadirGraficoAInforme: function (grafico) {
                var options = {title: 'Añadir a informe'};
                var opcionesExtra = {
                    deshabilitarBotones: true
                };

                return dialogService.open(DIALOG_ADD_A_INFORME_ID, DIALOG_ADD_A_INFORME_TEMPLATE,
                    grafico, options, opcionesExtra);
            },
            eliminarGraficoDeInforme: function (informe, grafico) {
                var urlBase = Sigo.url + '/api/v1/informes';
                var url = urlBase + '/' + informe.id + '/graficos/' + grafico.pivot.id;
                return $http.delete(url);
            }
        }
    }

// })();